export const MARK_COMPLETE_MODAL_ID = 'mark-complete';
